import { render } from "./DetailBackButton.vue?vue&type=template&id=7d977ba3"
import script from "./DetailBackButton.vue?vue&type=script&lang=js"
export * from "./DetailBackButton.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__